import React from "react";
import "../SecureShield.css";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { motion } from "framer-motion";

import {

    FaShieldAlt,
    FaBrain,
    FaLock,
    FaLaptopCode,
    FaServer,
    FaBug,
    FaChartLine,
    FaCloud,
    FaCheckCircle,
    FaArrowRight

} from "react-icons/fa";


import productImage from "../../../assets/dashboard-2.jfif";




const features = [

    {
        icon: <FaBrain />,
        title: "AI-Powered Threat Detection",
        text: "Detect advanced cyber threats using artificial intelligence and behavioral analysis."
    },

    {
        icon: <FaShieldAlt />,
        title: "Advanced Malware Protection",
        text: "Prevent malware, ransomware, spyware, and unknown threats."
    },

    {
        icon: <FaLaptopCode />,
        title: "Endpoint Monitoring",
        text: "Monitor laptops, desktops, and servers with real-time visibility."
    },


    {
        icon: <FaServer />,
        title: "Central Security Dashboard",
        text: "Manage security operations from a unified monitoring console."
    },


    {
        icon: <FaLock />,
        title: "Zero Trust Protection",
        text: "Verify every user, device, and application before access."
    },


    {
        icon: <FaChartLine />,
        title: "Security Analytics",
        text: "Generate insights with detailed reports and security intelligence."
    }

];





const SecureShield = () => {


    return (

        <>

            <Header />


            <title>
                BlueLotus Infrasafety Projects Private Limited SecureShield | Endpoint Security Platform
            </title>





            {/* HERO */}


            <section className="shield-hero">


                <div className="container">


                    <div className="shield-hero-content">


                        <span>

                            <FaShieldAlt />
                            Enterprise Security Product

                        </span>



                        <h1>

                            BlueLotus Infrasafety Projects Private Limited 
                            <span> SecureShield</span>

                        </h1>



                        <h3>

                            AI-Powered Endpoint Security Platform

                        </h3>



                        <p>

                            Protect your business endpoints against ransomware,
                            malware, phishing attacks, unauthorized access,
                            and advanced cyber threats with intelligent security
                            technology.

                        </p>


                        <a href="/consultation">

                            Request Product Demo
                            <FaArrowRight />

                        </a>


                    </div>


                </div>


            </section>









            {/* OVERVIEW */}



            <section className="shield-overview">


                <div className="container shield-grid">



                    <div>


                        <img

                            src={productImage}

                            alt="BlueLotus SecureShield"

                        />


                    </div>





                    <div>


                        <h2>

                            Next Generation Endpoint Protection

                        </h2>


                        <p style={{textAlign:"justify"}}>

                            BlueLotus Infrasafety Projects Private Limited SecureShield is an enterprise-grade endpoint
                            security platform designed to protect modern organizations
                            from continuously evolving cyber threats.

                        </p>


                        <p style={{textAlign:"justify"}}>

                            Combining artificial intelligence, behavioral analytics,
                            real-time monitoring, and zero trust security principles,
                            SecureShield identifies suspicious activities and stops
                            threats before they impact business operations.

                        </p>




                        <ul>

                            <li>
                                <FaCheckCircle />
                                Ransomware Prevention
                            </li>


                            <li>
                                <FaCheckCircle />
                                Real-Time Threat Detection
                            </li>


                            <li>
                                <FaCheckCircle />
                                Endpoint Visibility
                            </li>


                            <li>
                                <FaCheckCircle />
                                Automated Security Response
                            </li>


                        </ul>


                    </div>


                </div>


            </section>









            {/* FEATURES */}



            <section className="shield-features">


                <div className="container">


                    <h2>

                        Powerful Security Capabilities

                    </h2>



                    <div className="shield-feature-grid">


                        {

                            features.map((item, index) => (


                                <div className="shield-card" key={index}>


                                    <div className="shield-icon">

                                        {item.icon}

                                    </div>


                                    <h3>

                                        {item.title}

                                    </h3>


                                    <p>

                                        {item.text}

                                    </p>


                                </div>


                            ))

                        }


                    </div>


                </div>


            </section>









            {/* HOW WORK */}



            <section className="shield-process">


                <div className="container">


                    <h2>

                        How SecureShield Protects Your Business

                    </h2>



                    <div className="process-box">


                        <div>

                            <span>
                                01
                            </span>

                            <h3>
                                Detect
                            </h3>

                            <p>
                                AI engine analyzes activities and identifies threats.
                            </p>

                        </div>




                        <div>

                            <span>
                                02
                            </span>

                            <h3>
                                Analyze
                            </h3>

                            <p>
                                Behavior analytics evaluates suspicious actions.
                            </p>

                        </div>




                        <div>

                            <span>
                                03
                            </span>

                            <h3>
                                Respond
                            </h3>

                            <p>
                                Automatically blocks and contains attacks.
                            </p>

                        </div>




                        <div>

                            <span>
                                04
                            </span>

                            <h3>
                                Protect
                            </h3>

                            <p>
                                Continuous security monitoring keeps systems safe.
                            </p>

                        </div>



                    </div>


                </div>


            </section>









            {/* BENEFITS */}



            <section className="shield-benefits">


                <div className="container">


                    <h2>

                        Why Choose BlueLotus SecureShield?

                    </h2>


                    <div className="benefit-grid">



                        <div>

                            <FaBug />

                            <h3>

                                Stops Modern Threats

                            </h3>

                            <p>

                                Protection against ransomware,
                                malware, and advanced attacks.

                            </p>

                        </div>



                        <div>

                            <FaCloud />

                            <h3>

                                Enterprise Ready

                            </h3>

                            <p>

                                Designed for businesses,
                                servers, and cloud environments.

                            </p>

                        </div>



                        <div>

                            <FaChartLine />

                            <h3>

                                Security Intelligence

                            </h3>

                            <p>

                                Actionable analytics and
                                security visibility.

                            </p>

                        </div>



                    </div>


                </div>


            </section>










            {/* CTA */}


            <section className="shield-cta">


                <div className="container">


                    <h2>

                        Secure Your Endpoints With SecureShield

                    </h2>


                    <p>

                        Talk with our cybersecurity experts and discover
                        how BlueLotus Infrasafety Projects Private Limited SecureShield can protect your organization.

                    </p>


                    <a href="/contact">

                        Get Security Demo

                        <FaArrowRight />

                    </a>


                </div>


            </section>







            <Footer />


        </>

    )

}



export default SecureShield;